module.exports = __webpack_public_path__ + "f8d1a71c486d8bdb07713ddc2b2ed413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-cylinder-part.png
// module id = 810
// module chunks = 0